<template>
    <div>
        <!--1 Whats your set-->
        <div id="yourset" class="grid-container full container">
            <div class="grid-container">
                <div class="grid-x grid-padding-x   ">
                    <div class="cell large-3">
                        <ul class="accordion " style="margin: 0;background: lightgray;">
                            <li class="accordion-item">
                                <!-- Accordion tab title -->
                                <div
                                        href="#"
                                        class="accordion-title catalog-title text-uppercase"
                                        style="color: black;"
                                >
                                    Product Catalog
                                </div>
                            </li>
                        </ul>
                        <ul class="accordion" data-accordion data-multi-expand="true">
                            <li
                                    v-for="(item, index) in catalogList"
                                    :key="index"
                                    class="accordion-item"
                                    data-accordion-item
                            >
                                <!-- Accordion tab title -->
                                <a href="#" class="accordion-title" @click="catalogChange(item)">{{ item.name }}</a>

                                <!-- Accordion tab content: it would start in the open state due to using the `is-active` state class. -->
                                <div class="accordion-content" data-tab-content>
                                    <p>Panel 1. Lorem ipsum dolor</p>
                                    <a href="#">Nowhere to Go</a>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="cell large-9">
                        <div class="grid-x grid-padding-x">
                            <div class="cell large-8">
                                <ul class="accordion " style="margin: 0;background: lightgray;">
                                    <li class="accordion-item">
                                        <!-- Accordion tab title -->
                                        <div
                                                href="#"
                                                class="accordion-title catalog-title text-uppercase"
                                                style="color: black;" @click="showAll"
                                        >
                                            All
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="cell large-4">
                                <div class="input-group">
                                    <input
                                            class="input-group-field"
                                            type="text"
                                            placeholder="searh product..."
                                            v-model="searchStr"
                                    />
                                    <span class="input-group-label">
                                        <i class="fi-magnifying-glass"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="grid-x grid-padding-x grid-padding-y large-up-4">
                            <div
                                    class="cell "
                                    v-for="(item, index) in productFiltered"
                                    :key="index"
                            >
                                <div class="grid-x">
                                    <div class="cell">
                                        <router-link :to="{name:'product-detail', params:{productId:item.id, entity: item}}" class="card radius">
                                            <!--hover shadow-->
                                            
                                            <img
                                                    :src="baseUrl + item.imgPath"
                                            />
                                            <div class="card-section">
                                                <div class="grid-x text-center">
                                                    <a href="#" class=" clear large-2">
                                                        <i class="fi-mail"></i>
                                                    </a>
                                                    <a href="#inquire" class=" clear large-auto">
                                                        {{item.nameInfo.contentData}}
                                                    </a>
                                                    <a href="#" class="clear large-2">
                                                        <i class="fi-shopping-cart"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--4 Whats your set-->
        <div id="yourset" class="grid-container full container">
            <div class="grid-container">
                <div class="grid-x grid-padding-x grid-padding-y"></div>
            </div>

            <div class="grid-x grid-padding-x  grid-container ">
                <div class="cell container text-center">
                    <h2>
                        What's your set today?
                    </h2>
                    <p class="container">
                        Customize from <br/>
                        the basics sets
                    </p>

                    <a href="#" class="button radius shadow text-uppercase">
                        Learn More
                    </a>
                </div>
            </div>
        </div>

        <!--5 Default Sets-->
        <div id="defaultsets" class="grid-container full container">
            <div class="grid-container">
                <div class="grid-x grid-padding-x grid-padding-y"></div>
            </div>

            <div class="grid-x grid-container">
                <div
                        class="cell large-4 text-center"
                        v-for="(item, index) in ['Standard', 'Medium', 'Luxury']"
                        :key="index"
                >
                    <div class="grid-x ">
                        <div class="cell">
                            <div class="callout">
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>

                                <div class="card-section">
                                    <p>{{ item }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Space-->
        <div class="container"></div>
    </div>
</template>

<script>
    import catalogDataService from "@/store.catalog/services/main-service.js";
    import productDataService from "@/store.product/services/main-service.js";
    import configService from "@/app/config-service.js";

    export default {
        name: "productPage",
        mixins: [require("@/app/mixins/foundation")],
        data() {
            return {
                catalogList: [],
                products: [],
                currentCatalogId:null,
                currentCatalog:{},
                searchStr:''
            }
        },
        mounted() {
            this.getCatalogTree();
            this.getProductsByCatalogId();
        },
        computed:{
            baseUrl(){
                return configService.baseUrl;
            },
            catalogId(){
                return this.currentCatalogId ? this.currentCatalogId : this.$route.params.catalog;
            },
            productFiltered(){
                if(this.searchStr){
                    let _this = this;
                    return this.products.filter(function(e){
                        let properties = Object.values(e);
                        return properties.some(function(item){
                            if(item){
                                let type = Object.prototype.toString.call(item);
                                if(type === '[object Object]'){
                                    return Object.values(item).some(x => x && x.toString().toLocaleLowerCase().includes(_this.searchStr.toLocaleLowerCase()));
                                }else if(type === '[object String]'){
                                    return item.toString().toLocaleLowerCase().includes(_this.searchStr.toLocaleLowerCase());
                                }
                            }
                            return false;
                        });

                    });
                }else{
                    return this.products;
                }
            }
        },
        methods:{
            getCatalogTree(){
                let _this = this;
                catalogDataService.getTree().then(function(response){
                    _this.catalogList = response.data;
                });
            },
            getProductsByCatalogId(catalogId){
                let _this = this;
                if(catalogId && catalogId > 0){
                    productDataService.getProductsByCatalogId(this.catalogId).then(function(response){
                        _this.products = response.data;
                    });
                }else{
                    productDataService.get().then(function(response){
                        _this.products = response.data;
                    });
                }
            },
            catalogChange(catalog){
                this.currentCatalog = catalog;
                this.currentCatalogId = catalog.id;
                this.getProductsByCatalogId(this.currentCatalogId);
            },
            showAll(){
                this.getProductsByCatalogId();
            }
        }
    };
</script>

<style lang="scss">
    @import "./../../assets/sass/settings/settings";

    .catalog-title::before {
        content: "";
    }

    img {
        max-width: 100%;
        width: auto \9
    ;
        height: auto;
        vertical-align: middle;
        border: 0;
        -ms-interpolation-mode: bicubic;
    }

    #owl-demo .item img {
        display: block;
        width: 100%;
        height: auto;
    }

    .owl-carousel .item {
        //height: 30rem !important;
        //background: #4dc7a0;
        padding: 1rem;
    }

    .btns {
        display: table;
        margin: 30px auto;
    }

    .customNextBtn,
    .customPreviousBtn {
        float: right;
        background: #2d9070;
        color: #fff;
        padding: 10px;
        margin-left: 5px;
        cursor: pointer;
    }
</style>
